// extracted by mini-css-extract-plugin
module.exports = {"kontakt":"Kontakt_kontakt__2TMXT"};